<template>
  <div>
    <b-carousel class="carousel-responsive"
      id="carousel-1"
      v-model="slide"
      :interval="6000"
      controls
      indicators
      background="#111111"
      style="text-shadow: 0px 0px 0.1em #222, 0px 0px 0.5em #111, 0px 0px 1.0em #000;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide class="carousel-item" :style="{ backgroundImage: 'url(' + require('@/assets/pit_fight.jpg') + ')' }" style="background-size: cover; background-position: center center;">
        <h2 class="white-text"><em>Closed Alpha</em></h2>
        <h3 class="white-text">Going on Now</h3>
        <p class="white-text">Public Beta Coming in January 2020</p>
        <p><a href="https://www.patreon.com/bePatron?u=6740160"><img src="../assets/become_a_patron_button.png" alt="Become a Patron!" width="200" class="button-space" /></a></p>
        <p><b-button href="https://arena.playvq.com/" size="lg" variant="info" class="button-space no-text-shadow">Enter The Arena</b-button></p>
      </b-carousel-slide>

      <b-carousel-slide class="carousel-item" :style="{ backgroundImage: 'url(' + require('@/assets/falados.jpg') + ')' }" style="background-size: cover; background-position: center center;">
        <h2 class="white-text"><em>The Sun is Setting on MMORPGs</em></h2>
        <h3 class="white-text">The genre has grown old and stale. Its time for something ... <strong>NEW</strong></h3>
        <b-button href="/why/" size="lg" variant="info" class="button-space no-text-shadow">Why VQ is Different</b-button>
      </b-carousel-slide>

      <b-carousel-slide class="carousel-item" :style="{ backgroundImage: 'url(' + require('@/assets/journey.jpg') + ')' }" style="background-size: cover; background-position: center center;">
        <h2 class="white-text"><em>"A Journey of a Thousand Miles Begins with a Single Step"</em></h2>
        <div class="text-right white-text">-- Lao Tzu</div>
        <b-button href="/roadmap/" size="lg" variant="info" class="button-space no-text-shadow">Learn About the Journey</b-button>
      </b-carousel-slide>

      <b-carousel-slide class="carousel-item" :style="{ backgroundImage: 'url(' + require('@/assets/stronghold.jpg') + ')' }" style="background-size: cover; background-position: center center;">
        <h2 class="white-text">An Ever Expanding World</h2>
        <h3 class="white-text">For an experience and character that is uniquely <strong>YOURS</strong></h3>
        <b-button href="/about/" size="lg" variant="info" class="button-space no-text-shadow">About Vagabond's Quest</b-button>
      </b-carousel-slide>

    </b-carousel>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
      onSlideStart(slide) {
        this.slide = slide
        this.sliding = true
      },
      onSlideEnd(slide) {
        this.slide = slide
        this.sliding = false
      }
    }
  }
</script>

<style scoped>
.carousel,
.carousel-inner {
  height: 85vh;
}
.carousel-item {
  max-height: 85vh;
  min-height: 85vh;
  max-width: 100vw;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
.button-space {
  margin: 0.5em 1.0em;
}
.no-text-shadow {
  text-shadow: 0px 0px 0px #000;
}
.white-text {
  color: #fff;
}
</style>